import BaseMapper from '../../BaseMapper';

const PeriodScoreMapper = (data, context) => {
    return data;
};

export default PeriodScoreMapper;
